import { SliderProps } from "@mui/material";
import styled from "styled-components";

interface WrapperProps {
  extended: boolean;
}

export const SliderWrapper = styled.div<WrapperProps>`
  display: flex;
  margin: 32px 0 ${({ extended }) => (extended ? "32px" : "16px")} 64px;
  width: 80%;

  /* Prevent text overlap between the "advice-value"-marker and other markers */
  & > .MuiSlider-root > [data-index="2"] {
    @media (pointer: coarse) {
      top: 54px;
    }

    top: 50px;
  }
`;

export const sliderStyle: Required<SliderProps["sx"]> = {
  color: "#d38d89",
  height: 4,
  padding: "13px 0",
  width: "90%",
  "& .MuiSlider-thumb": {
    height: 28,
    width: 28,
    backgroundColor: "#bf0900",
    boxShadow:
      "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)",
    "&:focus, &:hover, &$active": {
      boxShadow:
        "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
    },
  },
  "& .MuiSlider-active": {},
  "& .MuiSlider-valueLabel": {
    background: "transparent",
    color: "#bf0900",
    fontSize: "18px",
    fontWeight: "600",
    top: 0,
    width: "max-content",
  },
  "& .MuiSlider-rail": {
    color: "#000000",
    opacity: 1,
    height: 4,
    borderRadius: 4,
  },
  "& .MuiSlider-mark": {
    display: "none",
  },
  "& .MuiSlider-markLabel": {
    color: "#000000",
  },
};
